<div id="contact-details" data-cy="contact-details">
  <div class="form" [formGroup]="control">
    <ife-title
      [title]="'modules.evcQuote.steps.personalDetails.steps.contactDetails.title' | translate"
      data-cy="contact-details-title"
    ></ife-title>

    <div class="max-w-2xl mx-auto">
      <ife-notification
        *ngIf="isFormGroupInvalid()"
        [notificationType]="notificationType.error"
        [notificationString]="'errors.form' | translate"
      ></ife-notification>

      <div class="sm:grid sm:grid-cols-2 sm:gap-x-8 mt-8">
        <div
          class="form-element input-text"
          [class.errors]="!control.get('name').pristine && control.get('name').touched && control.get('name').invalid"
        >
          <label for="name">
            {{ "modules.evcQuote.steps.personalDetails.steps.contactDetails.fields.name" | translate }}
          </label>

          <input id="name" name="name" type="text" formControlName="name" data-cy="input-name" autocomplete="off" />
          <div class="message">
            <span *ngIf="!control.get('name').pristine && control.get('name').touched && control.get('name').invalid">
              {{ "modules.evcQuote.steps.personalDetails.steps.contactDetails.errorMessage.name" | translate }}
            </span>
          </div>
        </div>

        <div
          class="form-element input-text"
          [class.errors]="
            !control.get('surname').pristine && control.get('surname').touched && control.get('surname').invalid
          "
        >
          <label for="surname">
            {{ "modules.evcQuote.steps.personalDetails.steps.contactDetails.fields.surname" | translate }}
          </label>
          <input
            id="surname"
            name="surname"
            type="text"
            formControlName="surname"
            data-cy="input-surname"
            autocomplete="off"
          />
          <div class="message">
            <span
              *ngIf="
                !control.get('surname').pristine && control.get('surname').touched && control.get('surname').invalid
              "
            >
              {{ "modules.evcQuote.steps.personalDetails.steps.contactDetails.errorMessage.surname" | translate }}
            </span>
          </div>
        </div>
      </div>

      <div
        class="form-element input-text mt-4"
        [class.errors]="
          !control.get('phoneNumber').pristine &&
          control.get('phoneNumber').touched &&
          control.get('phoneNumber').invalid
        "
      >
        <label for="phone-number">
          {{ "modules.evcQuote.steps.personalDetails.steps.contactDetails.fields.phoneNumber" | translate }}
        </label>
        <input
          id="phone-number"
          name="phone-number"
          type="text"
          formControlName="phoneNumber"
          data-cy="input-phone-number"
          autocomplete="off"
        />
        <div class="message">
          <span
            *ngIf="
              !control.get('phoneNumber').pristine &&
              control.get('phoneNumber').touched &&
              control.get('phoneNumber').invalid
            "
          >
            {{ "modules.evcQuote.steps.personalDetails.steps.contactDetails.errorMessage.phoneNumber" | translate }}
          </span>
        </div>
      </div>

      <div
        class="form-element input-text mt-4"
        [class.errors]="
          !control.get('fullAddress').pristine &&
          control.get('fullAddress').touched &&
          control.get('fullAddress').invalid
        "
      >
        <div class="flex">
          <label>
            {{ "modules.evcQuote.steps.personalDetails.steps.contactDetails.fields.fullAddress.label" | translate }}
          </label>
          <app-tooltip
            data-cy="tooltip"
            class="float-right"
            [content]="
              'modules.evcQuote.steps.personalDetails.steps.contactDetails.fields.fullAddress.tooltip' | translate
            "
          >
          </app-tooltip>
        </div>
        <app-google-autocomplete
          formControlName="fullAddress"
          data-cy="input-address"
          [defaultValue]="control.get('fullAddress').value"
          [alteredAddress]="alteredAddress"
          [addressType]="'address'"
          (setAddress)="setAddress($event)"
        >
        </app-google-autocomplete>
        <div class="message">
          <span
            *ngIf="
              !control.get('fullAddress').pristine &&
              control.get('fullAddress').touched &&
              control.get('fullAddress').invalid
            "
          >
            {{ "modules.evcQuote.steps.personalDetails.steps.contactDetails.errorMessage.fullAddress" | translate }}
          </span>
        </div>
      </div>

      <div class="grid grid-cols-2 gap-x-8 mt-4">
        <div
          class="form-element input-text"
          [class.errors]="
            !control.get('houseNumber').pristine &&
            control.get('houseNumber').touched &&
            control.get('houseNumber').invalid
          "
        >
          <label>
            {{ "modules.evcQuote.steps.personalDetails.steps.contactDetails.fields.houseNumber" | translate }}
          </label>

          <input
            id="houseNumber"
            name="house-number"
            type="text"
            formControlName="houseNumber"
            data-cy="input-house-number"
            autocomplete="off"
          />
          <div class="message">
            <span
              *ngIf="
                !control.get('houseNumber').pristine &&
                control.get('houseNumber').touched &&
                control.get('houseNumber').invalid
              "
            >
              {{ "modules.evcQuote.steps.personalDetails.steps.contactDetails.errorMessage.houseNumber" | translate }}
            </span>
          </div>
        </div>

        <div class="form-element input-text">
          <label>
            {{ "modules.evcQuote.steps.personalDetails.steps.contactDetails.fields.mailbox" | translate }}
          </label>
          <input
            id="mailbox"
            name="mailbox"
            type="text"
            formControlName="mailbox"
            data-cy="input-mailbox"
            autocomplete="off"
          />
        </div>
      </div>
    </div>

    <ife-navigation
      [showNext]="true"
      [disabledNext]="!control.valid"
      [showPrevious]="true"
      (nextStep)="navigate()"
      (previousStep)="navigateBack()"
    >
    </ife-navigation>
  </div>
</div>
